import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      Firstname: "",
      Lastname: "",
      IsAnonymous: true,
    }
  },
  getters: {
    name(state) {
      return state.user.Firstname + ' ' + state.user.Lastname;
    },
    isAnonymous(state) {
      return state.user.IsAnonymous;
    }
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload.user;
    }
  },
  actions: {
  },
  modules: {
  }
})
